import { Component, OnInit } from '@angular/core';
import { CheckAuth } from 'src/Services/utility.service';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ManageTRSModel } from 'src/Models/ManageTRSModel';
import { TrsMasterService } from 'src/Services/trs-master.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-manage-trs',
  templateUrl: './manage-trs.component.html',
  styleUrls: ['./manage-trs.component.css']
})
export class ManageTRSComponent implements OnInit {

  ckeConfig: any;
  tokenKey: string = '';
  objManageTRSModel = new ManageTRSModel();
  loginuserID: number;
  description = '';
  SelectedTool: string;

  constructor(private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private readonly _fb: FormBuilder,
    private readonly manageTRSMaster: TrsMasterService,
    private readonly checkAuth: CheckAuth,
    private readonly router: Router,    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.loginuserID = this.sessionStorageService.getAdminUserId();
    this.titleService.setTitle('Manage TRS');
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
  }

  ngOnInit() {

    this.ckeConfig = {
      versionCheck: false,
      toolbar: [
        {
          items:
            [
              'Undo', 'Redo', 'Link', 'Unlink', 'Anchor',
              'Image', 'Table', 'SpecialChar', 'Maximize', 'Source', 'Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat',
              'NumberedList', 'BulletedList', 'Outdent', 'Indent', 'Styles', 'Format', 'Font'
            ]
        }],
    }

    this.GetManageTRSDetails();
  }

  GetManageTRSDetails() {
    this.manageTRSMaster.GetManageTRSDetails(this.tokenKey).subscribe(data => {
      if (data['status'] !== 'Failure') {
        this.objManageTRSModel = data.result;
      }
    });

  }

  saveManageTRSDetails() {

    if (!this.objManageTRSModel.title) {
      this.showMessage('Please enter title.', 'Required', 'error');
      return;
    }
    if (!this.objManageTRSModel.description) {
      this.showMessage('Please enter description.', 'Required', 'error');
      return;
    }
    else {
      this.objManageTRSModel.userid = this.loginuserID;
      this.manageTRSMaster.SaveManageTRSDetails(this.tokenKey, this.objManageTRSModel).subscribe(data => {
        if (data['status'] !== 'Failure') {
          this.showMessage('Details Saved Successfully.', 'Success', 'success');
        }
        else {
          this.showMessage('Issue In Saving Your Details.', 'Error', 'error');
        }
      });
    }
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  Cancel() {
    let navigation = '/admin/jsi360/dashboard';
    this.router.navigate([navigation]);
  }

}
